import classNames from 'classnames'
import styles from './TextInputWrapper.module.css'
import { TextInputWrapperProps } from './types'

const TextInputWrapper = function TextInputWrapper({
  label,
  name,
  description,
  error,
  warning,
  id,
  required,
  children,
  invisibleLabel,
  errorDisplay,
  className,
  hint,
  fullWidth,
}: TextInputWrapperProps) {
  return (
    <div
      className={classNames(
        {
          ['fullWidth']: fullWidth && fullWidth !== 'mobile-only',
          ['fullWidthOnMobile']: fullWidth && fullWidth === 'mobile-only',
        },
        className
      )}
    >
      {label && (
        <label htmlFor={id || name} className={classNames(styles.label, invisibleLabel && 'sr-only')}>
          {label}
          {required && (
            <span aria-hidden className={styles.required}>
              *
            </span>
          )}
          {hint ? (
            <div className={classNames(styles.hint)} id={`${id}-hint`}>
              {hint}
            </div>
          ) : null}
        </label>
      )}
      {description && (
        <p id={`${name}-description`} className={styles.description}>
          {description}
        </p>
      )}
      {children}
      {error && errorDisplay === 'all' && (
        <p id={`${name}-error`} className={styles.error} aria-live="polite">
          {error}
        </p>
      )}
      {warning && errorDisplay === 'all' && (
        <p id={`${name}-warning`} className={styles.warning} aria-live="polite">
          {warning}
        </p>
      )}
    </div>
  )
}

export default TextInputWrapper
